import React, { useCallback, useRef, useState } from 'react';
import { Form, Mentions } from 'antd';
import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';
import { getData } from '../../actions/apiCall';
import { MentionsOptionProps, MentionsProps } from 'antd/es/mentions';


export type MentionedConfigProps = {
    api?: string;
    render: (record: any) => MentionsOptionProps[];
    mentionsProps?: MentionsProps
    formField?: {
        name: string;
        rules: any[];
    }
}

interface MentionsComponentProps {
    config: MentionedConfigProps;
}

const MentionsComponent: React.FC<MentionsComponentProps> = ({
    config
}) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const ref = useRef<string>(null);
    const dispatch = useDispatch();

    const loadData = async (key: string) => {
        if (!key) {
            setData([]);
            return;
        }
        try {
            const resData = await dispatch(getData(config.api, { search: key }));
            if (resData.code === 200) {
                if (ref.current !== key) return;
                setData(resData.data);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const debounceloadData = useCallback(debounce(loadData, 800), []);

    const onSearch = (search: string) => {
        ref.current = search;
        setLoading(!!search);
        setData([]);

        debounceloadData(search);
    };

    return (
        <Form.Item
            name={config?.formField?.name}
            rules={config?.formField?.rules}
        >
            <Mentions
                style={{ width: '100%' }}
                loading={loading}
                name={config?.formField?.name}
                onSearch={onSearch}
                options={config?.render(data)}
                {...config?.mentionsProps}
            />
        </Form.Item>
    );
};

export default MentionsComponent;